import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  module: {
    id: 'portal.views.courseProgress.hero.heading.module',
    defaultMessage: 'Module',
    description: 'Module label in course progress heading',
  },
  moduleProgress: {
    id: 'portal.views.courseProgress.section.moduleProgress',
    defaultMessage: 'Module progress',
    description: 'Module progress heading',
  },
  progressIntro: {
    id: 'portal.views.courseProgress.section.progressIntro',
    defaultMessage: 'This page shows your progress through the course. '
      + 'You advance by completing chapters, watching videos and answering quizzes correctly. '
      + 'We invite you to try attempting the quizzes as many times as you need.',
    description: 'Course progress intro paragraph',
  },
  iframeTitle: {
    id: 'portal.views.courseProgress.iframe.title',
    defaultMessage: 'Notes',
    description: 'Title for the embedded notes iframe',
  },
});

export default messages;
